export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  softwareCount: number;
}

export const categories: Category[] = [
  {
    slug: 'system-tools',
    name: '系统工具',
    description: '系统优化、垃圾清理、驱动管理、文件管理、系统备份等实用工具软件',
    icon: 'ri-computer-line',
    softwareCount: 156,
  },
  {
    slug: 'office-software',
    name: '办公软件',
    description: '文档编辑、表格处理、PDF工具、笔记软件、项目管理等高效办公利器',
    icon: 'ri-file-text-line',
    softwareCount: 203,
  },
  {
    slug: 'multimedia',
    name: '多媒体工具',
    description: '视频播放、音频处理、图像编辑、屏幕录制、格式转换等多媒体软件',
    icon: 'ri-image-line',
    softwareCount: 178,
  },
  {
    slug: 'security',
    name: '安全防护',
    description: '杀毒软件、防火墙、隐私保护、密码管理、系统安全检测等安全工具',
    icon: 'ri-shield-check-line',
    softwareCount: 89,
  },
  {
    slug: 'network-tools',
    name: '网络工具',
    description: '浏览器、下载工具、远程控制、网络监控、VPN等网络相关软件',
    icon: 'ri-global-line',
    softwareCount: 132,
  },
  {
    slug: 'dev-tools',
    name: '开发工具',
    description: '代码编辑器、版本控制、数据库管理、API测试、虚拟机等开发必备工具',
    icon: 'ri-code-s-slash-line',
    softwareCount: 145,
  },
  {
    slug: 'design-tools',
    name: '设计工具',
    description: 'UI设计、原型制作、图标设计、色彩管理、3D建模等创意设计软件',
    icon: 'ri-paint-brush-line',
    softwareCount: 67,
  },
  {
    slug: 'lifestyle',
    name: '生活娱乐',
    description: '电子书阅读、健身记录、菜谱管理、旅行规划、日历提醒等生活工具',
    icon: 'ri-heart-line',
    softwareCount: 94,
  },
];

export const categorySoftwareMap: Record<string, { name: string; description: string; icon: string; rating: number; downloads: string }[]> = {
  'system-tools': [
    { name: 'CCleaner Free', description: '全球知名的系统清理优化工具，快速清理垃圾文件、修复注册表', icon: 'ri-brush-line', rating: 4.8, downloads: '1250万+' },
    { name: 'Everything', description: '极速文件搜索工具，瞬间定位电脑中的任意文件', icon: 'ri-search-line', rating: 4.9, downloads: '980万+' },
    { name: '7-Zip', description: '开源免费的高压缩比压缩解压工具，支持多种格式', icon: 'ri-folder-zip-line', rating: 4.9, downloads: '2100万+' },
    { name: 'CPU-Z', description: '专业CPU检测工具，查看处理器、主板、内存等详细参数', icon: 'ri-cpu-line', rating: 4.7, downloads: '870万+' },
    { name: 'Recuva', description: '免费数据恢复工具，恢复误删除的重要文件', icon: 'ri-refresh-line', rating: 4.6, downloads: '760万+' },
    { name: 'Defraggler', description: '专业磁盘碎片整理工具，提升硬盘读写速度', icon: 'ri-hard-drive-line', rating: 4.5, downloads: '540万+' },
    { name: 'TeamViewer Free', description: '全球流行的免费远程控制与桌面共享软件', icon: 'ri-remote-control-line', rating: 4.7, downloads: '1560万+' },
    { name: 'Speccy', description: '详细系统信息查看工具，全面了解电脑硬件配置', icon: 'ri-information-line', rating: 4.6, downloads: '620万+' },
  ],
  'office-software': [
    { name: 'LibreOffice', description: '开源免费办公套件，完美替代Microsoft Office', icon: 'ri-file-word-line', rating: 4.7, downloads: '3200万+' },
    { name: 'WPS Office 免费版', description: '国产优秀办公软件，兼容Word/Excel/PPT格式', icon: 'ri-file-list-line', rating: 4.8, downloads: '5800万+' },
    { name: 'Notion Free', description: '全能笔记与知识管理工具，打造个人效率系统', icon: 'ri-sticky-note-line', rating: 4.9, downloads: '1800万+' },
    { name: 'PDF24 Creator', description: '完全免费的PDF创建、编辑、转换工具', icon: 'ri-file-pdf-line', rating: 4.7, downloads: '950万+' },
    { name: 'Obsidian', description: '强大的本地Markdown笔记软件，构建个人知识库', icon: 'ri-brain-line', rating: 4.8, downloads: '720万+' },
    { name: 'Trello Free', description: '直观的项目管理看板工具，团队协作更高效', icon: 'ri-trello-line', rating: 4.6, downloads: '2100万+' },
  ],
  'multimedia': [
    { name: 'VLC Media Player', description: '全能影音播放器，支持几乎所有音视频格式', icon: 'ri-play-circle-line', rating: 4.9, downloads: '4500万+' },
    { name: 'GIMP', description: '开源免费图像编辑软件，功能媲美Photoshop', icon: 'ri-image-edit-line', rating: 4.7, downloads: '1600万+' },
    { name: 'OBS Studio', description: '专业免费直播推流与屏幕录制软件', icon: 'ri-live-line', rating: 4.8, downloads: '2400万+' },
    { name: 'Audacity', description: '开源免费音频编辑录制软件，播客制作利器', icon: 'ri-mic-line', rating: 4.7, downloads: '1800万+' },
    { name: 'HandBrake', description: '开源视频转码工具，支持几乎所有视频格式转换', icon: 'ri-film-line', rating: 4.6, downloads: '1100万+' },
    { name: 'DaVinci Resolve Free', description: '好莱坞级专业调色与视频剪辑软件免费版', icon: 'ri-clapperboard-line', rating: 4.8, downloads: '890万+' },
  ],
  'security': [
    { name: 'Bitdefender Free', description: '轻量级免费杀毒软件，实时保护电脑安全', icon: 'ri-virus-line', rating: 4.8, downloads: '1200万+' },
    { name: 'Malwarebytes Free', description: '专业恶意软件查杀工具，清除顽固病毒木马', icon: 'ri-bug-line', rating: 4.7, downloads: '1800万+' },
    { name: 'Bitwarden', description: '开源免费密码管理器，安全存储所有账号密码', icon: 'ri-key-2-line', rating: 4.8, downloads: '960万+' },
    { name: 'Proton VPN Free', description: '注重隐私的免费VPN服务，安全浏览互联网', icon: 'ri-shield-user-line', rating: 4.5, downloads: '2100万+' },
    { name: 'GlassWire Free', description: '网络流量监控防火墙，可视化查看网络活动', icon: 'ri-radar-line', rating: 4.6, downloads: '430万+' },
  ],
  'network-tools': [
    { name: 'Google Chrome', description: '全球最流行的免费网络浏览器，快速安全稳定', icon: 'ri-chrome-line', rating: 4.8, downloads: '1.2亿+' },
    { name: 'FileZilla', description: '开源免费FTP客户端，文件传输管理利器', icon: 'ri-upload-cloud-line', rating: 4.6, downloads: '1400万+' },
    { name: 'qBittorrent', description: '开源轻量BT下载工具，无广告纯净体验', icon: 'ri-download-cloud-line', rating: 4.7, downloads: '890万+' },
    { name: 'Wireshark', description: '世界级网络协议分析工具，网络故障排查必备', icon: 'ri-wifi-line', rating: 4.8, downloads: '670万+' },
    { name: 'PuTTY', description: '经典免费SSH与Telnet客户端，远程服务器管理', icon: 'ri-terminal-line', rating: 4.7, downloads: '2300万+' },
  ],
  'dev-tools': [
    { name: 'VS Code', description: '微软开源免费代码编辑器，开发者首选工具', icon: 'ri-braces-line', rating: 4.9, downloads: '8900万+' },
    { name: 'Git', description: '分布式版本控制系统，团队协作开发必备', icon: 'ri-git-branch-line', rating: 4.9, downloads: '7600万+' },
    { name: 'DBeaver', description: '开源免费数据库管理工具，支持多种数据库', icon: 'ri-database-2-line', rating: 4.7, downloads: '560万+' },
    { name: 'Postman Free', description: 'API开发和测试工具，提升接口调试效率', icon: 'ri-send-plane-line', rating: 4.7, downloads: '3200万+' },
    { name: 'VirtualBox', description: '开源免费虚拟机软件，一台电脑运行多个系统', icon: 'ri-stack-line', rating: 4.6, downloads: '2800万+' },
  ],
  'design-tools': [
    { name: 'Figma Free', description: '云端协作UI设计工具，免费版满足个人设计需求', icon: 'ri-layout-line', rating: 4.8, downloads: '2300万+' },
    { name: 'Blender', description: '开源免费3D创作套件，建模动画渲染全流程', icon: 'ri-shapes-line', rating: 4.8, downloads: '1800万+' },
    { name: 'Inkscape', description: '开源矢量图形编辑软件，专业SVG设计工具', icon: 'ri-pen-nib-line', rating: 4.6, downloads: '670万+' },
    { name: 'Krita', description: '开源免费数字绘画软件，插画师和概念设计师首选', icon: 'ri-brush-2-line', rating: 4.7, downloads: '520万+' },
  ],
  'lifestyle': [
    { name: 'Calibre', description: '免费电子书管理工具，支持格式转换与设备同步', icon: 'ri-book-open-line', rating: 4.7, downloads: '890万+' },
    { name: 'MyFitnessPal Free', description: '热门免费健身与饮食记录App，科学管理健康', icon: 'ri-heart-pulse-line', rating: 4.6, downloads: '3200万+' },
    { name: 'Google Calendar', description: '免费云端日历工具，高效管理日程安排', icon: 'ri-calendar-line', rating: 4.8, downloads: '1.5亿+' },
    { name: 'Spotify Free', description: '全球领先免费音乐流媒体服务，海量歌曲在线听', icon: 'ri-music-line', rating: 4.7, downloads: '2.8亿+' },
    { name: 'Duolingo', description: '全球最受欢迎的免费语言学习应用，轻松学外语', icon: 'ri-translate', rating: 4.8, downloads: '5.6亿+' },
  ],
};